/* @flow */
import Lead from 'entities/Lead';
import Leads from 'collections/Leads';
import LeadStore from 'stores/LeadStore';
import { ActionTypes } from 'constants/LeadConstants';
import { dispatcher } from 'lib/Dispatcher';

const LeadActions = {
  loadLead(userId: number) {
    return Lead.fetch().then(lead => {
      dispatcher.dispatch({
        type: ActionTypes.LOAD_LEAD,
        lead,
        userId,
      });
    });
  },

  deleteLead() {
    return Lead.delete();
  },

  loadLeads(forceLoad: boolean = false): Promise<?Leads> {
    if (!forceLoad && LeadStore.isLoaded()) {
      return Promise.resolve();
    }
    return Leads.fetch().then(leads => {
      dispatcher.dispatch({
        type: ActionTypes.LOAD_LEADS,
        leads,
      });
      return leads;
    });
  },

  sendInvitations(leadIds: number[], context: string): Promise<void> {
    return Leads.sendInvitations(leadIds, context).then(() => {
      dispatcher.dispatch({
        type: ActionTypes.INVITE_LEADS,
        leadIds,
      });
      LeadActions.loadLeads(true);
    });
  },
};

export default LeadActions;



// WEBPACK FOOTER //
// ./src/actions/LeadActions.js